import { Saga } from 'redux-saga'
import {
  ActionPattern,
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects'
import { submitQuizz } from 'src/graphql/Services/Quizzes/mutations'
import { QuizzQuestionYesOrNo } from 'src/types'
import { User } from 'src/types/fam-graphql'

import Router from '../../routes/router'
import routes from '../../routes/definitions'
import { actions, selectors } from '..'
import ApiSagas from '../api/sagas'

export default class QuizzSagas {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  static *init() {}

  static *submitQuizz() {
    const values = yield select(selectors.quizz.quizzValues)

    const input = {
      question_1: values.question1,
      question_2: values.question2 === QuizzQuestionYesOrNo.YES,
      question_3:
        values.question2 === QuizzQuestionYesOrNo.YES ? values.question3 : 0,
      question_4:
        values.question2 === QuizzQuestionYesOrNo.YES ? values.question4 : 0,
      question_5: values.question5 === QuizzQuestionYesOrNo.YES,
      question_6:
        values.question5 === QuizzQuestionYesOrNo.YES ? values.question6 : 0,
      question_7:
        values.question5 === QuizzQuestionYesOrNo.YES ? values.question7 : 0,
      question_8: values.question8,
      question_9: values.question9 === QuizzQuestionYesOrNo.YES,
      question_9_bis:
        values.question9 === QuizzQuestionYesOrNo.YES
          ? values.question9_alt
          : 0,
      question_10:
        values.question9 === QuizzQuestionYesOrNo.YES ? values.question10 : 0,
      question_11: values.question11 === QuizzQuestionYesOrNo.YES,
      question_12:
        values.question11 === QuizzQuestionYesOrNo.YES ? values.question12 : 0,
      question_13:
        values.question11 === QuizzQuestionYesOrNo.YES ? values.question13 : 0,
      question_14: values.question14 === QuizzQuestionYesOrNo.YES,
      question_14_bis: values.question14_bis === QuizzQuestionYesOrNo.YES,
      question_15: {
        recurrence:
          values.question14 === QuizzQuestionYesOrNo.YES
            ? values.question15_1
            : 0,
        duration:
          values.question14 === QuizzQuestionYesOrNo.YES
            ? values.question15_2
            : 0,
      },
      question_15_bis: {
        recurrence:
          values.question14_bis === QuizzQuestionYesOrNo.YES
            ? values.question15_bis_1
            : 0,
        duration:
          values.question14_bis === QuizzQuestionYesOrNo.YES
            ? values.question15_bis_2
            : 0,
      },
      question_16: values.question16,
      question_17: values.question17,
    }

    const results = yield call(ApiSagas.mutate, submitQuizz(input))

    if (results.data.latest_quiz.id) {
      yield put(actions.user.setUser(results.data as User))
      Router.pushRoute(routes.quizzResult.name, {
        slug: results.data.latest_quiz.id,
      })
    }
  }

  static *loop() {
    yield all([
      takeLatest(
        actions.quizz.quizzRequest as ActionPattern,
        QuizzSagas.submitQuizz as Saga
      ),
    ])
  }
}
